<template>
  <v-dialog v-model="active" width="400">
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData"></slot>
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <v-card>
      <v-card-title>Add Major</v-card-title>
      <v-card-text>
        <v-autocomplete v-model="majorToAdd" :items="majorItems" :label="action === 'add' ? 'Major to Add' : (action === 'declare' ? 'Major to Declare' : 'Change Major to')" outlined />
        <v-select v-model="advisor" :items="advisorOptions" label="Requested Advisor" outlined />
        <v-autocomplete v-model="concentrations" :disabled="concentrationOptions.length === 0" :items="concentrationOptions" label="Concentration(s)" outlined multiple />
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="majorToAdd === '' || advisor === ''" @click="save()" text>Add Major</v-btn>
        <v-spacer />
        <v-btn text @click="active = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'

export default {
  props: {
    action: {
      type: String,
      required: true
    },
    majorItems: {
      type: Array,
      required: true
    }
  },
  setup (props, { root, emit }) {
    const settingServ = root.$feathers.service('student/reg-setting')

    const active = ref(false)

    const title = computed(() => {
      if (props.action === 'add') return 'Add Major'
      else if (props.action === 'drop') return 'Drop Major'
      else return 'Change Major'
    })

    const majorToChange = ref('')
    const majorToAdd = ref('')
    const majors = ref([])
    const majorOptions = computed(() => majors.value.filter(({ value }) => value !== majorToAdd.value))

    const advisor = ref('')
    const advisorOptions = ref([])

    const concentrations = ref([])
    const concentrationOptions = ref([])

    watch(majorToAdd, async () => {
      if (majorToAdd.value) {
        const { data } = await settingServ.find({ query: { form: 'program', category: 'advisor', major: majorToAdd.value, $sort: { term: -1 }, $limit: 1 } })
        if (data.length === 0) {
          alert('There was an error loading the advisors for the selected major. Please contact the Records office for assistance.')
          return
        } else {
          advisorOptions.value = data[0].options
        }
        const { data: concData } = await settingServ.find({ query: { form: 'program', category: 'concentration', major: majorToAdd.value, $sort: { term: -1 }, $limit: 1 } })
        if (concData.length === 0) {
          alert('There was an error loading the concentrations for the selected major. Please contact the Records office for assistance.')
        } else {
          concentrationOptions.value = concData[0].options
        }
      }
    })

    async function save () {
      const obj = { value: majorToAdd.value, advisor: advisor.value, concentrations: concentrations.value }
      emit('save', obj)
      active.value = false
    }

    return {
      active,
      title,
      majorToChange,
      majorToAdd,
      majors,
      majorOptions,
      advisor,
      advisorOptions,
      concentrations,
      concentrationOptions,
      save
    }
  }
}
</script>
